import React from "react";
import { SectionCard } from "./common";
import { SchemaForm } from "./forms";
import { GoldButton, OutlineButton } from "@/components/Primitives";
import { api } from "@/lib/api";
import { UploadCloud, FileText, History } from "lucide-react";
import { toast } from "sonner";

const SCHEMA = [
  { key: "lender", label: "Current Lender" },
  { key: "loan_number", label: "Loan Number" },
  { key: "interest_rate", label: "Interest Rate (%)", type: "number" },
  { key: "loan_type", label: "Loan Type", type: "select", options: ["Variable", "Fixed", "Split"] },
  { key: "repayment_type", label: "Repayment", type: "select", options: ["Interest Only", "Principal & Interest"] },
  { key: "remaining_balance", label: "Remaining Balance", type: "number" },
  { key: "loan_term_years", label: "Loan Term (years)", type: "number" },
  { key: "fixed_expiry_date", label: "Fixed Expiry Date", type: "date" },
  { key: "next_review_date", label: "Next Review Date", type: "date" },
  { key: "offset_account", label: "Offset Account" },
  { key: "monthly_repayment", label: "Monthly Repayment", type: "number" },
  { key: "notes", label: "Notes" },
];

export function MortgageTab({ property, reload, onUpload }) {
  const save = async (payload) => { await api.put(`/properties/${property.id}/mortgage`, payload); reload(); };
  return (
    <div className="space-y-6">
      <SectionCard title="Mortgage details" action={
        <div className="flex flex-wrap gap-2">
          <OutlineButton data-testid="mortgage-upload-statement" onClick={() => onUpload("Mortgage")}><UploadCloud size={14} /> Upload Mortgage Statement</OutlineButton>
          <OutlineButton data-testid="mortgage-upload-contract" onClick={() => onUpload("Mortgage")}><FileText size={14} /> Upload Loan Contract</OutlineButton>
          <OutlineButton data-testid="mortgage-refi-history" onClick={() => toast.info("Refinancing history arrives in a later sprint.")}><History size={14} /> Refinancing History</OutlineButton>
        </div>
      }>
        <SchemaForm schema={SCHEMA} initial={property.mortgage || {}} onSave={save} testidPrefix="mortgage" />
      </SectionCard>
      <SectionCard title="Mortgage Timeline">
        <div data-testid="mortgage-timeline-placeholder" className="border-2 border-dashed border-[#E4DACB] rounded-xl py-10 text-center text-[#A99F90] text-sm">
          Mortgage timeline will appear here in a future sprint.
        </div>
      </SectionCard>
    </div>
  );
}
